import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const LiveDot = ({ color, text, ...rest }) => (
<svg width="17" height="17" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="68" height="68" fill="url(#pattern0_9_3)" />
  <defs>
    <pattern id="pattern0_9_3" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_9_3" transform="scale(0.0147059)" />
    </pattern>
    <image id="image0_9_3" width="68" height="68" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAADtUlEQVR4Ae2c7VHjMBCGd2Vg+MNMroNQwUEFJBUAFdx1wFEBSQVwFVyogFABUAGhAkwF5xn+MIRItyvJ+XBssJNLYlt6ZoScWEPiN6uv1UoIa0Lt7jZhOGwB4ndQqknpwN5qJoqGlCIqx2lA5Z5AiAEOhwNYAwgrQjUaDXh9PaHLI3oozhuwHCzQPeW3sLfXxyiKoAqora0WpUslxF9KamUpCP6o7e0DKCtaiCC4W6kI6cLc8WdDWeBfaSNCzAtzo9upjQlBbQR9kYuNCzGfLmAJFmpU9S/x/n5Dl2WtwyHs7LTx7S2EgggoCJnmDxLjEcorBsM/2CNZyy8oSCFBtDkq1YPlu9B1wN/xsmgVyl1l7D/uQDXpoJTdPAVzCVJxMWJyifKlIDURI+ZLUT4VhMQ4o+wK6gTiTxyNrjNvZ92wXSv3JlVoQIsQUZd8mNUlZwsixDPMz0TrwgCkbCOLkyC127XtRhPqywFkjFHmLMRWlWdwgSA4TPpZ5i1kOLwEV5By7llnLERPo6W8A5cQoo0fH/fjlzM3lVpqplhJEs88thDtfRqNHsFFpqxkYiFSnoGrSHkSX2oLUTz4Ih8ouEtEouzzuMRYSBCcgNs0Yg3iKnMMrqPUEWemypjqUrc5S1Eimgl/E3Ztw3UxmAa1pU1BjUmZfaPrJQhaYmqN1UNaCL347DHQIjxbiG8/Ysg4uNv1gkyBvPwHnjGFV+7qjhckgRckAQsSgicm9BYySyR0pJ/HgBjxwOwFPAalnryFTENaIE95wSxbeqQ89A6iCcZBZF/cguso9cCZEcSETLuNEH3OppchuB1xt9pQdRkvQ9g4iWtwl14cKzIZqVqTcRIpf8eXY0H02qaLbQk9M3JEkUUkbuaK5awViWeeEcQ5K0HsT8eG6LeSZZwKizAL3OH0W3PTfxtz5ULV6WKKLyg1LNOOSzi0qq6LWCEN0/fTbqQ6iNDES5xCShxnDeBna2fdzPSYaXNCPIf6kVpVYj51IeJo1IN6tSddqiqfxu7n3R7SoazqEYosRuerQkU2EHWguqLkEoMptAmxoqLkFoMpvCvTbuxjUcruKuCt8ee2HczNYttUjR+WxylNKCe8/eMUF1iEW2ihCicDmzL2QF27FyaETcDWohBvNr6jm7fbl2lk7Q9DyEAfjiBEb8VC8FEcV6sQYqFGNQ9qEi59TC7+FvyfA1XYzflA7ok+rmietTJBkmg/C8fEchioOXaHBeLUTBQN9V9z3M6Lzre37xc52GAR/gEUBezX+pxbPQAAAABJRU5ErkJggg==" />
  </defs>
</svg>

)
/* --------------------------------------------- */
LiveDot.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Text inside icon. */
  text: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
LiveDot.defaultProps = {
  color: 'transparent',
  text: 25,
  style: {
    width: 17,
    height: 17,
    marginRight: 6
  }
}
/* --------------------------------------------- */
export default LiveDot
/* --------------------------------------------- */
